module.exports = __webpack_public_path__ + "img/logo-en.eccf3a28.svg";